import { h, Host } from "@stencil/core";
var Directions;
(function (Directions) {
    Directions["Asc"] = "asc";
    Directions["Desc"] = "desc";
    Directions["None"] = "";
})(Directions || (Directions = {}));
export class TableDataSort {
    constructor() {
        this.sortField = undefined;
        this.sortedDirection = "";
    }
    domElement;
    /** when the sort Button is clicked it emits the asc or desc name  */
    sortEvent;
    sort() {
        // eslint-disable-next-line @typescript-eslint/switch-exhaustiveness-check
        switch (this.sortedDirection) {
            case Directions.Asc:
                this.sortedDirection = Directions.Desc;
                break;
            case Directions.Desc:
                this.sortedDirection = Directions.None;
                break;
            default:
                this.sortedDirection = Directions.Asc;
        }
        this.sortEvent.emit({
            name: this.sortField,
            direction: this.sortedDirection
        });
        // @ts-expect-error Check for typing
        const allSorters = this.domElement.closest("tr").querySelectorAll("ux-table-data-sort");
        [].forEach.call(allSorters, (element) => {
            if (element.isEqualNode(this.domElement)) {
                return;
            }
            element.sortedDirection = Directions.None;
        });
    }
    render() {
        const baseClass = "ux-table-data-sort";
        return (h(Host, { key: 'c9a3d9ab773c2980496160bd7a86b865b88d8940', class: baseClass, onClick: () => this.sort() }, h("slot", { key: 'bbe3de54ebbe00a1d79c591786188cf65cd64115' }), "\u00A0", h("ux-icon", { key: '4d84885edc010deeb6bf0de4f913fb49bbd14535', class: `${baseClass}__icon`, name: "sort", weight: "bold" })));
    }
    static get is() { return "ux-table-data-sort"; }
    static get originalStyleUrls() {
        return {
            "$": ["table-data-sort.scss"]
        };
    }
    static get styleUrls() {
        return {
            "$": ["table-data-sort.css"]
        };
    }
    static get properties() {
        return {
            "sortField": {
                "type": "string",
                "mutable": false,
                "complexType": {
                    "original": "string",
                    "resolved": "string",
                    "references": {}
                },
                "required": false,
                "optional": false,
                "docs": {
                    "tags": [],
                    "text": "This is the name of the sort field used in the sort click event"
                },
                "attribute": "sort-field",
                "reflect": false
            },
            "sortedDirection": {
                "type": "string",
                "mutable": false,
                "complexType": {
                    "original": "\"\" | \"asc\" | \"desc\"",
                    "resolved": "\"\" | \"asc\" | \"desc\"",
                    "references": {}
                },
                "required": false,
                "optional": false,
                "docs": {
                    "tags": [],
                    "text": "indicates in which direction the data is already sorted. This has to be empty when it is not sorted yet.\nSetting this does not trigger the sorting event. Clicking the button will update this attribute."
                },
                "attribute": "sorted-direction",
                "reflect": true,
                "defaultValue": "\"\""
            }
        };
    }
    static get events() {
        return [{
                "method": "sortEvent",
                "name": "uxTableSort",
                "bubbles": true,
                "cancelable": true,
                "composed": true,
                "docs": {
                    "tags": [],
                    "text": "when the sort Button is clicked it emits the asc or desc name"
                },
                "complexType": {
                    "original": "any",
                    "resolved": "any",
                    "references": {}
                }
            }];
    }
    static get elementRef() { return "domElement"; }
}
//# sourceMappingURL=table-data-sort.js.map
